import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/** Üst bardaki zil: genel bildirim özeti (30.10.2026, #511 / #512). Yalnız yetkili olunan ve adedi 0'dan büyük satırlar gelir. */
export interface BildirimSatiri {
    /** "PO_ESLESME" | "PO_BITIS" | "EK_MESAI_RED" | "EK_MESAI_YANIT_YOK"; yeni tür eklenince BildirimZili'ne de satır eklenir. */
    kod: string
    adet: number
    /** Tıklanınca açılacak kayıtlar (ek mesai satırları). */
    idler?: string[] | null
}

export class BildirimService {
    static async ozet(): Promise<{ isSuccess: boolean, message?: string, data: BildirimSatiri[] }> {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/Bildirim/Ozet', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}
